// extracted by mini-css-extract-plugin
var _1 = "TeacherButton__buttonText--ykhSR";
var _2 = "TeacherButton__icon--g2d41";
var _3 = "TeacherButton__iconCyan--Ir_es";
var _4 = "TeacherButton__link--W49Ak";
var _5 = "TeacherButton__main--GbkXe fontSize__teacherButton--gEx30";
var _6 = "TeacherButton__mainDisabled--uqz0c TeacherButton__main--GbkXe fontSize__teacherButton--gEx30";
var _7 = "TeacherButton__showsolution--xw7Fs";
var _8 = "TeacherButton__wrapper--MsuK2 CoreGeneral__roboto--UlmjE CoreGeneral__buttonBase--ihAxH";
var _9 = "TeacherButton__wrapperDisabled--aCeUc";
export { _1 as "buttonText", _2 as "icon", _3 as "iconCyan", _4 as "link", _5 as "main", _6 as "mainDisabled", _7 as "showsolution", _8 as "wrapper", _9 as "wrapperDisabled" }
